
import { useEffect } from 'react';

function setMetaByName(name, content) {
  if (!content) return;
  let tag = document.querySelector(`meta[name="${name}"]`);
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute('name', name);
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', content);
}

function setMetaByProperty(property, content) {
  if (!content) return;
  let tag = document.querySelector(`meta[property="${property}"]`);
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute('property', property);
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', content);
}

function setCanonical(href) {
  if (!href) return;
  let tag = document.querySelector('link[rel="canonical"]');
  if (!tag) {
    tag = document.createElement('link');
    tag.setAttribute('rel', 'canonical');
    document.head.appendChild(tag);
  }
  tag.setAttribute('href', href);
}

const PageTitle = ({ title, description, noIndex = false, canonical }) => {
  useEffect(() => {
    const appName = 'MarkazSync';
    const isStandalone =
      window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone;
    const nextTitle = title || appName;
    if (isStandalone) {
      document.title = nextTitle;
    } else {
      document.title = nextTitle === appName ? appName : `${nextTitle} | ${appName}`;
    }

    const fullTitle = document.title;
    setMetaByName('robots', noIndex ? 'noindex, nofollow' : 'index, follow');

    if (description) {
      setMetaByName('description', description);
      setMetaByProperty('og:description', description);
      setMetaByName('twitter:description', description);
    }

    setMetaByProperty('og:title', fullTitle);
    setMetaByName('twitter:title', fullTitle);
    setCanonical(canonical || window.location.href.split('#')[0]);
  }, [title, description, noIndex, canonical]);

  return null; // it doesn't render anything
};

export default PageTitle;
